import React, { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import SearchAthletes from "./SearchAthletes";
import './Search.css';
import toastr from "toastr";

export default function SearchInput({sport, stat, setLoading, setAthletes, setAthletesLoading, getAthletes}) {

  const [searchInput, setSearchInput] = useState("");
  const typingTimer = useRef(null);
  const shrk = $("#shrk").val() == '1';

  const handleSearch = (newInput) => {

    setSearchInput(newInput);
    clearTimeout(typingTimer.current);
    typingTimer.current = setTimeout(() => {
      if (newInput === "") {
        setAthletes([]);
        getAthletes(sport, stat);
        return;
      }

      setAthletesLoading(true);
      SearchAthletes(sport, newInput.toLowerCase()).then((response) => {
        if (!response || shrk) {
          toastr["warning"]("No athletes found matching search.", "Notice");
          getAthletes(sport, stat);
          return;
        }
        setLoading(false);
        setAthletes(response);
        setAthletesLoading(false);
      });
    }, 1500);
  };

  const clearSearch = () => {
    setSearchInput('');
    setAthletes([]);
    getAthletes(sport, stat);
  };

  return (
    <div className="col-md-5 col-sm-12 mb-3 p-010">
      <label htmlFor="search-input" className="sr-only">Search Athletes</label>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          id="search-input"
          placeholder="Search"
          value={searchInput}
          onChange={(e) => handleSearch(e.target.value)}
        />
        {searchInput && (
          <button className="clear-button" onClick={clearSearch}>
            &times;
          </button>
        )}
      </span>
    </div>
  )
}